<!-- <pos-app-spinner> </pos-app-spinner> -->
<div class="container-fluid py-2">
  <form [formGroup]="updatePartnerEnrollmentForm">
    <div class="row">
      <div class="text-center p-2">
        <h5>
          <label> {{ partnerProgrammeName }} </label>
        </h5>
      </div>
      <div class="col-4">
        <pos-app-lib-customer-search
          [customerType]="'retail'"
          (selectNewCustomer)="selectCustomer($event)"
          [forOrderSearch]="true"
          [selectedCustomerName]="
            selectedCustomer ? selectedCustomer?.customerName + ' (' + selectedCustomer?.customerNumber + ')' : selectedCustomerName || ''
          "
          [showSearchIcon]="true"
          [removeCustomerAfterLoad]="true"
          placeHolder="CUSTOMER SEARCH"
          (focus)="isFocus($event)"
        ></pos-app-lib-customer-search>
      </div>
      <div class="col-8 row">
        <div class="col-2">
          <label class="m-2">PARTNER </label>
        </div>
        <div class="col-6">
          <input
            class="form-control col-3"
            [value]="selectedCustomer ? selectedCustomer?.customerName + ' (' + selectedCustomer?.customerNumber + ')' : ''"
            readonly="true"
          />
        </div>
        <div class="col-4">
          <button class="btn btn-secondary" type="button" [disabled]="!selectedCustomer?.customerName" (click)="addPartnerToProgram()">
            ADD TO PROGRAMME
          </button>
        </div>
      </div>
    </div>
  </form>
  <div class="card shadow-sm mt-4">
    <div class="card-body">
      <div class="text-start">
        <h5>
          <label>ENROLLED PARTNERS</label>
        </h5>
        <div class="table-responsive tableFixHead">
          <table class="border my-2 table table-bordered">
            <thead>
              <tr>
                <th scope="col" class="text-uppercase text-center">
                  <label>Action</label>
                </th>
                <th scope="col" class="text-uppercase text-center">
                  <label>PARTNER</label>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let customer of customerEnrolledList; let i = index">
                <td>
                  <div class="d-flex justify-content-center">
                    <mat-icon (click)="delete(i)" title="Save">delete</mat-icon>
                  </div>
                </td>
                <td>
                  <div>{{ customer.customerName }} ({{ customer.customerNumber }})</div>
                  <div></div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- pre populate enrolled partner -->
  </div>
</div>
